import dayjs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';

dayjs.extend(durationPlugin);

const formatSingleNumber = (number: number): string => number.toString().padStart(2, '0');

export interface StringDateTimeLeft {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}

export const formatCounterToStringDate = (remainingTimeInMs: number): StringDateTimeLeft => {
  const duration = dayjs.duration(remainingTimeInMs);

  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  const daysString = formatSingleNumber(days);
  const hoursString = formatSingleNumber(hours);
  const minutesString = formatSingleNumber(minutes);
  const secondsString = formatSingleNumber(seconds);

  return {
    days: daysString,
    hours: hoursString,
    minutes: minutesString,
    seconds: secondsString,
  };
};

export const formatCounterToStringWithSingleZeros = (timeInMs: number) => {
  if (timeInMs == null) return null;

  const duration = dayjs.duration(timeInMs);
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
};
